var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-container bg-color"},[_c('topnavigation'),_c('div',{staticClass:"app_main"},[_c('Nav'),_c('div',{staticStyle:{"flex":"1"}},[_c('router-view')],1)],1)],1),(_vm.dialogShow)?_c('appDialog',{on:{"closePopup":function (){this$1.dialogShow=false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }